module.exports = __webpack_public_path__ + "img/pic_shop_top@2x.fa7542d1.png";